import { MarketInput } from 'generated/graphql';

export const DEFAULT_ADMIN_PROFILE_ID = '0';
export const DEFAULT_EMPTY_ID_STATE = '';
// Truck ID meaning the user explicitly chose collection (no truck); '0' means no explicit choice yet.
export const NO_TRUCK_SELECTED_ID = '-1';

export const isMarketStateSet = (marketInput: MarketInput | undefined | Partial<MarketInput>) => {
  return marketInput && marketInput.buyerID && marketInput.buyerID !== DEFAULT_EMPTY_ID_STATE;
};

// A buyer is only selected when the ID is neither empty nor the '0' admin sentinel. The BE
// answers cart(buyerID: 0) with the admin's own profile and a cart group whose buyerUUID is 0,
// so '0' arrives from the server as well as from the market state store, as a number or a
// string. Anything derived from a buyer ID must go through here rather than a truthiness check:
// both 0 and '0' are values that survive `??` and a bare `!!`.
export const isBuyerSelected = (buyerID: string | number | undefined | null): buyerID is string | number => {
  if (buyerID === undefined || buyerID === null) return false;
  const id = buyerID.toString().trim();
  return id !== DEFAULT_EMPTY_ID_STATE && id !== DEFAULT_ADMIN_PROFILE_ID;
};

// The backend only understands '0' as "no truck"; the '-1' collection sentinel is a
// frontend-only value that must be normalized before it reaches the market query.
export const marketQueryTruckTypeUUID = (truckTypeUUID: string | undefined | null) =>
  !truckTypeUUID || truckTypeUUID === NO_TRUCK_SELECTED_ID ? DEFAULT_ADMIN_PROFILE_ID : truckTypeUUID;

// The backend parses buyerID as an int64 and rejects the whole query for anything else, so a
// non-numeric value (e.g. a stringified undefined) is sent as the '0' no-buyer sentinel.
export const marketQueryBuyerID = (buyerID: string | undefined | null) => {
  const id = buyerID?.trim() ?? '';
  return /^\d+$/.test(id) ? id : DEFAULT_ADMIN_PROFILE_ID;
};
